import { IAddress } from '../../../shared/contact/address.interface';
import { IClientShipping } from '../../client';
const fromAddress = (address: IAddress): string =>
  address
    ? [
        address.street1,
        address.street2,
        address.street3,
        address.city,
        address.state,
        address.postalCode,
        address.country,
      ]
        .filter((value) => value != null)
        .join(', ')
    : '';

const fromClientShipping = (address: IClientShipping): string =>
  address
    ? [
        address.address,
        address.addressLine2,
        address.addressLine3,
        address.city,
        address.state,
        address.postalCode,
        address.country,
      ]
        .filter((value) => value != null)
        .join(', ')
    : '';

export const formatInlineAddress = {
  fromAddress,
  fromClientShipping,
};
